import { redirect } from '@tyro/router/utils';
import { getStripeAccount } from '../api/stripe-accounts';

export const stripeAccountGuard = async () => {
  const { fees_stripeAccount: account } = await getStripeAccount();

  return !account.onboardingComplete ? redirect('/fees/setup') : null;
};
